import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const ArrowCircleRight = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15.7 12.7L12.7 15.7C12.3 16.1 11.7 16.1 11.3 15.7C10.9 15.3 10.9 14.7 11.3 14.3L12.6 13H9C8.4 13 8 12.6 8 12C8 11.4 8.4 11 9 11H12.6L11.3 9.7C10.9 9.3 10.9 8.7 11.3 8.3C11.7 7.9 12.3 7.9 12.7 8.3L15.7 11.3C16.1 11.7 16.1 12.3 15.7 12.7Z"
      fill="currentColor"
    />
  </svg>
)

export default ArrowCircleRight
